import React, { useContext, useEffect, useState } from 'react'
import { useFetch } from '../../api/FetchApiData';
import { MediaUrl } from '../../utils/Media';
import { AppContext, UserContext } from '../../../AppContextProvider';
import { isMobile } from 'react-device-detect';
import { TeachButton } from '../../utils/ButtonLoader';
import { t } from 'i18next';
if (isMobile)
    import('./mob_rayon.css').then(() => {});
else
    import('./rayon.css').then(() => {});

function RayonForm({action, close=()=>{}, rayons=[],setRayons,rayon={name:'',id:null,image:null,is_new:true,categories:[]}}) 
{
    //const [_rayons,setRayons] = useState(rayons);
    const [_rayon,setRayon] = useState(rayon)
    const [selRayons,setSelRayons] = useState([]);
    const [UserState, setUserState] = useContext(UserContext);
    const [AppState,setAppState] = useContext(AppContext);
    const [notification,setNotification] = useState({text:'',color:'black'});
    const fetchData = useFetch();
    const [imageChanged,setImageChanged] = useState(false);
    
    useEffect(()=>{
        if(action==="Modifier")
            {setRayon(rayon);}
    },[rayon])
       
    const OnCheckBoxChange = (event)=>{
        const checked_id = event.target.value;
        if(event.target.checked) 
        {selRayons.push({id:parseInt(checked_id)});setSelRayons([...selRayons]);}
        else
        {selRayons.pop({id:parseInt(checked_id)});setSelRayons([...selRayons]);}
        setTimeout(()=>{console.log(selRayons);},3000);
        
    }
    
    const db_image = ()=>
    {
        //console.log(rayon);
        if(!!rayon.image)
        {
            let url = "";
            try{
                url = MediaUrl(rayon.image.image);
                return(<img className="UserInput" style={{width:"60%",display:'inline-block',marginLeft:'10px',borderRadius:'10px'}} src={url}  />);
            }
            catch(error){console.log(error)}
        }
    }

    const uploaded_image = ()=>
    {
        if((!!_rayon.image && _rayon.is_new) || imageChanged)
        {
            let url = "";
            try{
                url = URL.createObjectURL(_rayon.image);
                return(<img className="UserInput" style={{width:"60%",display:'inline-block',marginLeft:'10px',borderRadius:'10px'}} src={url}  />);
            }
            catch(error){}
        }
        else
        { return db_image();}
    }

    const ExecAction = (close)=>
    {
        if(action==="Nouveau")
        {
            const _rayon_ = {'name':_rayon.name,'is_new':true,'categories':[]};
            _rayon.categories.forEach(cat => {
                if(cat.name!=='')
                    _rayon_.categories.push({name:cat.name});
            });
            var image = _rayon.image;
            var formdata = new FormData();
            formdata.append('data',JSON.stringify(_rayon_));
            formdata.append('image',image,image.name);
            fetchData.PostFormData(formdata,'rayon/').then(result=>
                {
                    if(result.result)
                    {
                        setNotification({text:"Rayon ajouté avec succès",color:'green'});
                        setTimeout(()=>{setNotification({text:"",color:"black"});setRayons(result.rayons);close();},3000);
                    }
                    else
                    {
                        setNotification({text:result.errors[0],color:'orangered'});
                        setTimeout(()=>{setNotification({text:"",color:"black"})},3000);
                    }
                });
        }
        else if(action === "Modifier")
        {
            //Modifier
            const _rayon_ = {'name':_rayon.name,'id':_rayon.id,'categories':[]};
            _rayon.categories.forEach(cat => {
                if(cat.name!=='')
                   !!cat.id ? _rayon_.categories.push({id:cat.id,name:cat.name}) : _rayon_.categories.push({name:cat.name});
            });
            console.log(_rayon_);
            var formdata = new FormData();
            formdata.append('data',JSON.stringify(_rayon_));
            if(imageChanged)
                formdata.append('image',_rayon.image,_rayon.image.name);
            
            fetchData.PutFormData(formdata,'rayon/').then(result=>
                {
                    console.log(result);
                    if(result.result)
                    {
                        setNotification({text:"Rayon modifié avec succès",color:'green'});
                        setTimeout(()=>{setNotification({text:"",color:"black"});setRayons(result.rayons);close();},3000);
                    }
                    else
                    {
                        setNotification({text:result.errors[0],color:'orangered'});
                        setTimeout(()=>{setNotification({text:"",color:"black"});},3000);
                    }
                });
              
        }
        else 
        {
            //Supprimer
            if(selRayons.length>0)
            {
                const data = {ids:selRayons};
                fetchData.DeleteData(selRayons,'rayon/').then((response)=>
                    response.json()).then(result=>
                    {
                        console.log(result);
                        if(result.result)
                        {
                            setNotification({text:"Rayons Supprimés avec succès",color:'green'});
                            setTimeout(()=>{setNotification({text:"",color:"black"});setRayons(result.rayons);close();},5000);
                        }
                        else
                        {
                            setNotification({text:result.errors[0],color:'orangered'});
                            setTimeout(()=>{setNotification({text:"",color:"black"});},5000);
                        }
                    });
            }
        }
    }


    let trigger_color = (action==="Supprimer") ? '#FFCCCB' : 'lightgreen';
    trigger_color = (action==="Modifier") ? 'lightblue' : trigger_color; 

    const Form = (close)=>
    {
        if(action==="Nouveau" || action==="Modifier")
        {
            return(
                <>
                    <div  className="rayon-DivInput">
                        <label className='rayon-label'>{t('authentication.nom')} </label>
                        <input style={{border:'1px solid lightgray',textAlign:'center'}} value={_rayon.name}  onChange={e=>{setRayon({..._rayon,name:e.target.value})}} className="rayon-UserInput" name="name" type="text" placeholder={t('authentication.nom')}/>
                    </div>

                    <div style={{marginTop:'10px'}} className="rayon-DivInput">
                        <label className='rayon-label' style={{verticalAlign:'middle'}}>{t('filters.categories')} </label>
                        <div className='rayon-div-cat'>
                            {
                                _rayon.categories.map((cat,index)=>{return(
                                    <div key={index} style={{width:'100%',marginTop:'5px'}}>
                                        <input className='rayon-cat-input' disabled={!!cat.id} name={index.toString()}  placeholder = 'name' value={_rayon.categories[index].name}  onChange={e=>{_rayon.categories[index].name = e.target.value; setRayon({..._rayon});}} type="text"/>
                                        <input className='btn-del-cat' onClick={e=>{_rayon.categories.splice(index,1);setRayon({..._rayon})}} name={index.toString()} style={{backgroundColor:'#FFCBCC',borderRadius:'5px'}} type='button' value={"supprimer"} />
                                    </div>)})
                            }
                            {(AppState.settings.lang==='fr') &&<input onClick={e=>{_rayon.categories.push({name:'name',caracteristics:[],articles:[]});setRayon({..._rayon})}} type='button' value={t('ajout-produit.ajouter')} style={{margin:'10px',width:'70%',height:'35px',border:'none',borderRadius:'5px',backgroundColor:'skyblue'}} />}
                            {(AppState.settings.lang!=='fr') &&<span style={{fontSize:'x-small',color:'orangered'}}>{t("ajout-produit.lang-ajout-cat")}</span>}
                        </div>
                    </div>

                    <div className="rayon-DivInput">
                        <label className='rayon-label'>{t('ajout-produit.image')} </label>
                        <input style={{minHeight:'40px',borderRadius:'0px'}} accept="image/png,image/jpeg,image/jpg" /*onClick={e=>{setRayon({...rayon,image:e.target.files[0]});}}*/ onChange={e=>{setRayon({..._rayon,image:e.target.files[0]});setImageChanged(true)}} multiple={false} type="file" name="rayon_image" className="UserInput"/>
                    </div>
                    <div style={{textAlign:'center'}} className="rayon-DivInput">
                            {uploaded_image()}
                        </div>
                    <div  style={{textAlign:'center'}} className="rayon-DivInput">
                        <input onClick={e=>{ExecAction(close);}} style={{margin:'10px',height:'40px',minWidth:'25%',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:trigger_color}} type='button' value={t("user-info.enregistrer")} />
                        <input onClick={close} style={{margin:'10px',height:'40px',minWidth:'25%',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:'orangered'}} type='button' value={t("ajout-produit.annuler")} />
                        {/*<TeachButton id={_rayon.id} target={'rayon'} width='50%' />*/}
                    </div>
                </>
            );
        }
        else
        {
            return(
            <div style={{textAlign:'center'}}>
            {
                rayons.map((ray,index)=>{
                    return(
                        <div key={index} style={{margin:'auto',marginTop:'10px',width:'80%',border:'1px solid lightgray',padding:'10px',borderRadius:'5px'}}>
                            <label style={{marginRight:'80px'}}>{ray.name}</label>
                            <input type='checkbox' value={ray.id} onChange={(e)=>{OnCheckBoxChange(e)}} />
                        </div>
                    );
                })
            }
            <div style={{textAlign:'center'}} className="rayon-DivInput">
                <input onClick={(e)=>{ExecAction(close);}} style={{margin:'10px',height:'40px',minWidth:'40%',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:trigger_color}} type='button' value={"Supprimer"} />
                <input onClick={close} style={{margin:'10px',height:'40px',minWidth:'40%',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:'orangered'}} type='button' value={"Annuler"} />
            </div>
            </div>);
        }
    }

    if(action==='Modifier'&& (rayon.id===null || rayon.id===undefined))
        return(
            <div className='rayon-form'>
                <fieldset className='rayon-fieldset'>
                    <label style={{color:'orangered'}}>Aucun rayon n'a été sélectionné</label><br/>
                    <input type='button' style={{height:'25px',padding:'5px 20px 5px 20px',marginTop:'10px'}} value={'OK'} onClick={e=>{close()}} />
                </fieldset>
            </div>
        );

    return(
        <div className='rayon-form'>
            <fieldset className='rayon-fieldset'>
                <div className="rayon-DivInput" style={{textAlign:'center',color:'orangered'}}>
                    <p style={{color:notification.color}}>{notification.text}</p>
                </div>
                {Form(close)}
            </fieldset>
        </div>
    );
}

export default RayonForm;
